var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-date-picker',{attrs:{"type":"datetime","placeholder":"选择日期时间","value-format":"timestamp","size":"small"},on:{"change":_vm.timeChange},model:{value:(_vm.myValue),callback:function ($$v) {_vm.myValue=$$v},expression:"myValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }